/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:c6deb938-2617-4ad2-996b-04048126b4da",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_XIqb63CRd",
    "aws_user_pools_web_client_id": "2a840ak9s5en3cb978gq7ttbho",
    "oauth": {
        "domain": "medeo-dev.auth.eu-west-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "stripe",
            "endpoint": "https://tjny5dptt4.execute-api.eu-west-1.amazonaws.com/develop",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
